export default __webpack_public_path__ + "static/media/icn-user-search.05d89e09.svg";